import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { RoleBaseModel } from "@tecumseh/Services/RoleBasePageService";
import { Draft } from "immer";

type RoleBasePageState = Readonly<{
    isLoadingRoleBasePage: boolean;
    contentResults: RoleBaseModel[]
}>;

const initialState: RoleBasePageState = {
    isLoadingRoleBasePage: false,
    contentResults: []
};

const reducer = {
    "Custom/RoleBasePage/BeginFetchingContents": (draft: Draft<RoleBasePageState>) => {
        draft.isLoadingRoleBasePage = true;
    },
    "Custom/RoleBasePage/SetContents": (draft: Draft<RoleBasePageState>, action: { contentResults: RoleBaseModel[] }) => {
        draft.contentResults = action.contentResults;
        draft.isLoadingRoleBasePage = false;
    },
    "Custom/RoleBasePage/CompletedFetchingContents": (draft: Draft<RoleBasePageState>) => {
        draft.isLoadingRoleBasePage = false;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
